module.exports = __webpack_public_path__ + "media/application/images/svgs/pause-circle-41c9e0ba857caa90bfc55e37ecfbdaa8.svg";